import { CoreMenu } from "@core/types";

export const menu: CoreMenu[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    translate: "MENU.DASHBOARD.COLLAPSIBLE",
    type: "item",
    icon: "home",
    url: "dashboard",
  },
  {
    id: "apps",
    type: "section",
    title: "Wallet",
    translate: "MENU.Wallet.SECTION",
    icon: "package",
    children: [
      {
        id: "AW",
        title: "Alimenter mon Wallet",
        translate: "MENU.Wallet.AW.COLLAPSIBLE",
        type: "collapsible",
        icon: "dollar-sign",
        children: [
          {
            id: "PC",
            title: "Par Carte de paiement",
            translate: "MENU.Wallet.AW.Carte",
            type: "item",
            icon: "circle",
            url: "pages/CashinCarte",
          },
          {
            id: "ES",
            title: "Par versement/virement",
            translate: "MENU.Wallet.AW.Espece",
            type: "item",
            icon: "circle",
            url: "pages/CashinEspece",
          },
          {
            id: "rv",
            title: "Via un revendeur",
            translate: "MENU.Wallet.AW.RV",
            type: "item",
            icon: "circle",
            url: "pages/Revendeurs",
          },
        ],
      },
      {
        id: "TA",
        title: "Transférer de l’argent",
        translate: "MENU.Wallet.TA.COLLAPSIBLE",
        type: "collapsible",
        icon: "arrow-up-right",
        children: [
          {
            id: "ws",
            title: "Wallet SPW",
            translate: "MENU.Wallet.TA.ws",
            type: "item",
            icon: "circle",
            url: "pages/transfertverswallet",
          },
          {
            id: "cb",
            title: "Compte bancaire",
            translate: "MENU.Wallet.TA.cb",
            type: "item",
            icon: "circle",
            url: "pages/transfertversbancaire",
          },
        ],
      },
    ],
  },
  {
    id: "services",
    type: "section",
    title: "Services",
    translate: "MENU.SERVICE.SECTION",
    icon: "package",
    children: [
      {
        id: "rt",
        title: "Recharge Téléphonique",
        translate: "MENU.SERVICE.RT.COLLAPSIBLE",
        type: "collapsible",
        icon: "phone",
        children: [
          {
            id: "td",
            title: "Transfert direct",
            translate: "MENU.SERVICE.RT.TD",
            type: "item",
            icon: "circle",
            url: "pages/transfertdirect",
          },
          {
            id: "cr",
            title: "Carte de recharge",
            translate: "MENU.SERVICE.RT.CR",
            type: "item",
            icon: "circle",
            url: "pages/carterecharge",
          },
        ],
      },
      {
        id: "DS",
        title: "Divertissement",
        translate: "MENU.SERVICE.DS.COLLAPSIBLE",
        type: "item",
        icon: "arrow-up-right",
        url: "pages/divertissements",
      },
      {
        id: "pm",
        title: "Paiement Marchand",
        translate: "MENU.SERVICE.PM.COLLAPSIBLE",
        type: "item",
        icon: "shopping-cart",
        url: "pages/paiement-marchand",
      },
      // {
      //   id: 'GCB',
      //   title: 'Gestion des cartes',
      //   translate: 'MENU.SERVICE.GCB.COLLAPSIBLE',
      //   type: 'item',
      //   icon: 'credit-card',
      //   url: 'pages/cartebancaire',
      //   hidden: true
      // }
    ],
  },
  {
    id: "autres",
    type: "section",
    title: "****",
    translate: "MENU.AUTRE.SECTION",
    icon: "package",
    children: [
      {
        id: "FP",
        title: "Programme de fidélité",
        translate: "MENU.AUTRE.FP.COLLAPSIBLE",
        type: "item",
        icon: "gift",
        url: "pages/fidelisation",
      },
      {
        id: "MT",
        title: "Transactions",
        translate: "MENU.AUTRE.MT.COLLAPSIBLE",
        type: "item",
        icon: "repeat",
        url: "pages/historique",
      },
      {
        id: "MC",
        title: "Consommation",
        translate: "MENU.AUTRE.MC.COLLAPSIBLE",
        type: "item",
        icon: "activity",
        url: "pages/consommation",
      },
    ],
  },
  {
    id: "faq",
    title: "FAQ et Contact",
    translate: "MENU.FAQ.SECTION",
    type: "item",
    icon: "zap",
    url: "pages/faq",
  },
  {
    id: "marchand-autres",
    type: "section",
    title: "****",
    translate: "MENU.AUTRE.SECTION",
    icon: "package",
    hidden: true,
    children: [
      {
        id: "dashboard-marchand",
        title: "dashboard marchand",
        translate: "MENU.AUTRE.dashm.COLLAPSIBLE",
        type: "item",
        icon: "home",
        url: "pages/dash-marchand",
        hidden: true,
      },
      /*{
        id: "compte-marchand",
        title: "Mon compte",
        translate: "MENU.AUTRE.moncompte.COLLAPSIBLE",
        type: "item",
        icon: "user",
        url: "pages/moncompte-marchand",
        hidden: true,
      },
      {
        id: "transfert-marchand",
        title: "Transfert et virements",
        translate: "MENU.AUTRE.trvr.COLLAPSIBLE",
        type: "item",
        icon: "arrow-up-right",
        url: "pages/trvr-marchand",
        hidden: true,
      },
      {
        id: "hist-dash",
        title: "Historique",
        translate: "MENU.AUTRE.his.COLLAPSIBLE",
        type: "item",
        icon: "repeat",
        url: "pages/historique-marchand",
        hidden: true,
      },
      {
        id: "con-dash",
        title: "Consommation",
        translate: "MENU.AUTRE.conso.COLLAPSIBLE",
        type: "item",
        icon: "activity",
        url: "pages/conso-marchand",
        hidden: true,
      },*/
    ],
  },
];
